import {Popup, Position, ToolbarItem} from 'devextreme-react/popup';
import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {SelectBox} from "devextreme-react/select-box";
import {NumberBox} from "devextreme-react/number-box";
import {useRef, useState} from "react";

export function FullRadiusPopupControl() {
    const adapterContext = useEEToolAdapterContext()
    const radDirectionSource = [{name: 'Radius Out', value: 1}, {name: 'Radius In', value: -1}];
    const refRadDepth = useRef<NumberBox>(null);

    const getOKButtonOptions = {
        stylingMode: 'contained',
        text: 'OK',
        onClick: () => {
            adapterContext.handleFullRadius(refRadDepth.current?.instance.option('value') ?? 0, adapterContext.radDirection);
        },
    };

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => adapterContext.hidePopupFullRadius()
    };

    if (!adapterContext.popupFullRadiusVisible)
        return <></>;

    return (
        <>
            <Popup
                title='Enter Radius Width and Depth'
                visible={adapterContext.popupFullRadiusVisible}
                width={adapterContext.popupSize.width}
                height={adapterContext.popupSize.height}
                hideOnOutsideClick={true}
                showCloseButton={true}
                onHidden={() => adapterContext.hidePopupFullRadius()}
            >
                <Position at={'left top'} my={'left top'} offset={{
                    x: adapterContext.popupLocation.left,
                    y: adapterContext.popupLocation.top
                }}></Position>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getOKButtonOptions}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <div>
                    <div className="dx-field">
                        <NumberBox
                            defaultValue={adapterContext.radDepth}
                            width={'100%'}
                            label='Depth'
                            labelMode={'outside'}
                            ref={refRadDepth}
                        />
                    </div>
                    <div className="dx-field">
                        <SelectBox
                            label={"Direction:"}
                            labelMode={'outside'}
                            width={'100%'}
                            dataSource={radDirectionSource}
                            displayExpr="name"
                            valueExpr="value"
                            value={adapterContext.radDirection}
                            onValueChanged={(e) => adapterContext.setRadDirection(e.value)}
                            searchEnabled={false}
                        />
                    </div>
                </div>
            </Popup>
        </>
    );
}
